import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100%;
`;

export const List = styled.div`
  width: 190px;
  padding-top: 30px;
  border-right: 1px solid #eaeaea;
  overflow-y: auto;

  .skeletonTemplate {
    margin: 0px 16px;
    width: auto;
  }

  .skeletonToday {
    margin-top: 5px;
    div:first-child {
      margin-bottom: 0px;
    }
  }

  .skeletonMonth {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 30px 0px 5px 0px;
    border-bottom: 1px solid #eaeaea;

    div:first-child {
      margin-bottom: 5px;
    }
  }

  .skeletonDate {
    margin: 6px 0px 6px 0px;
  }
`;

export const ListContent = styled.div`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ListItem = styled.div`
  line-height: 1.6;
  padding: 1px 16px 1px 8px;
  position: relative;
`;


export const ConfigMenuItem = styled.li`
  color: #444444;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 3px;
  line-height: 1.2;

  cursor: pointer;
  font-weight: ${props => (props.menuItemActive ? "500" : "400")};

  &:hover {
    background-color: rgba(68, 173, 248, 0.12);
  }

  &:before {
    content: '';
    background-color: #50aff4;
    position: absolute;
    top: 0;
    left: ${props => props.menuItemActive ? "0" : "-6px"};
    height: 100%;
    width: 3px;
    border-radius: 0 10px 10px 0;
    -webkit-transition: 0.25s left cubic-bezier(0.55,0.3,0.5,0.9);
    transition: 0.25s left cubic-bezier(0.55,0.3,0.5,0.9);
  }

  background-color: ${props => props.menuItemActive && "rgba(68, 173, 248, 0.12)"};

  .currentVersion {
    color: #9A9A9A;
    font-weight: 400;
  }
`;

export const VersionDetails = styled.div`
  text-transform: uppercase;
  padding-bottom: 5px;
  margin: 25px 16px 5px 18px;
  color: #3A3A3A;
  border-bottom: 1px solid #EAEAEA;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .month {
    font-weight: 500;
    font-size: 12px;
    color: #3A3A3A;
  }

  .year {
    color: #9A9A9A;
    font-weight: 400;
  }
`;

export const Content = styled.div`
  flex: 1;
  flex-direction: column;
  width: 100%;
  background-color: #F7F7F7;
  padding: 20px 30px;
  overflow: hidden;
  overflow-x: hidden;
  position: relative;
`;

export const Display = styled.div`
  overflow: hidden;
  padding: 0;
  margin: 0;
  box-shadow: 2px 2px 5px rgb(0 0 0 / 15%);
  
  iframe {
    height: 1120px;
    width: 1600px;
    padding: 0;
    margin: 0;
    zoom: 1;
    -moz-transform: scale(0.5);
    -moz-transform-origin: 0 0;
    -o-transform: scale(0.5);
    -o-transform-origin: 0 0;
    -webkit-transform: scale(0.5);
    -webkit-transform-origin: 0 0;
  }
`;

export const Header = styled.div`
  display: flex;
	justify-content: space-between;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  margin-top: 10px;
  display: flex;
  align-content: center;
`;
